// set data để render markers điểm trong tuyến

import Direction from '@/components/map/direction'
const { getDirection } = Direction()
export default (storeKey?: string, mapIntance?: any) => {
  if (!storeKey) {
    storeKey = 'system'
  }

  const { map } = $store()
  const { $formatters } = useNuxtApp()

  const markers = ref<{ [key: string]: any }>({})
  const routes = ref<{ [key: string]: any }>({})
  const draggable = ref<boolean>(true)
  const mapLoading = ref<{ [key: string]: boolean }>({
    marker: false,
    route: false
  })

  const routingPositions = ref({} as { [key: string]: any }) // thông tin vẽ tuyến chinh
  const tollStations = ref([] as { [key: string]: any }[]) // trạm thu phí
  const locations = ref([] as { [key: string]: any }[]) // điểm

  const showLocation = computed(() => {
    return map.getShowLocation[storeKey]
  })

  const CLatLngLocationRoutes = computed(() => {
    return [...tollStations.value, ...locations.value]
  })

  const setMarkers = (positions: { [key: string]: any }[], options?: any) => {
    tollStations.value = []
    locations.value = []

    if (validatePositions(positions)) {
      let originData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
      let destinationData: google.maps.LatLngLiteral = { lat: 0, lng: 0 }
      let originLocationName = 'A'
      let destinationLocationName = 'B'
      const waypointsData: { location: google.maps.LatLngLiteral; node?: string; locationName?: string }[] = []

      positions.forEach((s: any, i: number) => {
        const lat = parseFloat(s.lat?.toString())
        const lng = parseFloat(s.lng?.toString())

        // markers điểm
        locations.value.push({ lat, lng, locationName: s.locationName } as google.maps.LatLngLiteral)

        const ts = getRoutingPosition(positions[i]?._id, positions[i + 1]?._id).tollStations
        const tsDetails = getRoutingPosition(positions[i]?._id, positions[i + 1]?._id).tollStationDetails

        if (ts && ts?.length) {
          ts?.forEach((t: any, index: number) => {
            if (!t?.locationId) {
              t = tsDetails?.[index]
            }

            if (t?.locationId) {
              tollStations.value.push({ lat: t.lat, lng: t.lng, nodeId: t.locationId, locationName: t.locationName } as google.maps.LatLngLiteral)
            }
          })
        }

        if (i === 0) {
          originData = { lat, lng } as google.maps.LatLngLiteral
          originLocationName = s.locationName
          return
        }
        if (i === positions.length - 1) {
          destinationData = { lat, lng } as google.maps.LatLngLiteral
          destinationLocationName = s.locationName
          return
        }

        waypointsData.push({
          location: { lat, lng } as google.maps.LatLngLiteral,
          node: s.node,
          locationName: s.locationName
        })
      })

      markers.value = {
        originData,
        destinationData,
        waypointsData,
        options: {
          ...{
            originLocationName,
            destinationLocationName,
            sameOriginDestination: originData.lat === destinationData.lat && originData.lng === destinationData.lng,
            renderMarkerByIndexNumber: false
          },
          ...(options || {})
        }
      }
    } else {
      positions.forEach((s: any, i: number) => {
        if (s.locationId) {
          locations.value.push({ lat: s.lat, lng: s.lng, locationName: s.locationName } as google.maps.LatLngLiteral)
        }
      })
      markers.value = {}
    }
  }

  // setup data để vẻ tuyến
  // tách nhỏ tuyến để vẻ A -> B -> C  ==>  A -> B, B -> C
  const setRoutes = async (positions: { [key: string]: any }[], options?: any) => {
    const r = []

    if (!validatePositions(positions)) {
      routes.value = {
        routes: []
      }

      routingPositions.value = {}
      return
    }

    for (let i = 0; i < positions?.length - 1; i++) {
      let overViewPolyLine = getOverViewPolyLine(positions[i]._id, positions[i + 1]._id)

      const originData = {
        lat: parseFloat(positions[i].lat),
        lng: parseFloat(positions[i].lng)
      }
      const destinationData = {
        lat: parseFloat(positions[i + 1].lat),
        lng: parseFloat(positions[i + 1].lng)
      }
      if (!overViewPolyLine) {
        const directionData = await getDirection(originData, destinationData)
        const { routes } = directionData || {}
        if (!Array.isArray(routes) || routes.length < 1) {
          continue
        }
        overViewPolyLine = routes[0].overview_polyline
      }
      r.push({
        originData,
        destinationData,
        data: {
          startLocation: positions[i]._id,
          endLocation: positions[i + 1]._id,
          nodeLocationName: positions[i].nodeLocationName,
          overViewPolyLine
        }
      })
    }

    const origin = {
      lat: parseFloat(positions[0].lat),
      lng: parseFloat(positions[0].lng)
    }

    const destination = {
      lat: parseFloat(positions[positions?.length - 1].lat),
      lng: parseFloat(positions[positions?.length - 1].lng)
    }

    const defaultOptions = {
      originLocationName: positions[0].nodeLocationName,
      destinationLocationName: positions[positions?.length - 1].nodeLocationName,
      sameOriginDestination: origin.lat === destination.lat && origin.lng === destination.lng,
      renderMarkerByIndexNumber: true,
      multiple: true
    } as { [key: string]: any }

    routes.value = {
      routes: r,
      options: {
        ...defaultOptions,
        ...(options || {})
      }
    }
  }

  const validatePositions = (positions: { [key: string]: any }[]): boolean => {
    if (!Array.isArray(positions)) {
      return false
    }

    if (positions.length < 2) {
      return false
    }

    return true
  }

  const updateDirections = async (directions: any) => {
    mapLoading.value.route = true
    if (!directions || !directions.length) {
      return
    }

    let durationH = 0
    let distanceKm = 0

    const legs = directions
      .map((item: any) => {
        const { routes } = item?.renderer?.directions

        if (!routes || !routes.length) {
          return null
        }

        const route = routes[0]
        if (!route || !route.legs || !route.legs.length) {
          return null
        }

        const ceilSeconds = (seconds: number): number => {
          const minutes = Math.ceil(seconds / 60)
          return minutes * 60
        }

        const leg = route.legs[0]
        const duration = leg.duration ? ceilSeconds(leg.duration.value) : 0
        const distance = leg.distance ? leg.distance.value : 0

        const { startLocation, endLocation } = item.data

        durationH += $formatters.sToH(duration)
        distanceKm += $formatters.mToKm(distance)

        return {
          duration,
          distance,
          startAddress: leg.start_address,
          endAddress: leg.end_address,
          overViewPolyLine: route.overview_polyline,
          startLocation,
          endLocation
        }
      })
      .filter((item: any) => item !== null)

    let drew = false
    if (draggable.value) {
      drew = true
    }

    routingPositions.value = {
      route: {
        duration: $lodash.round(durationH, 2),
        distance: $lodash.round(distanceKm, 2),
        legs,
        drew
      }
    }

    if (legs.length) {
      await setTolltation()
    }
    mapLoading.value.route = false
  }

  const getOverViewPolyLine = (startPositionId: string, endPositionId: string) => {
    const leg = getRoutingPosition(startPositionId, endPositionId)

    return leg?.overViewPolyLine || ''
  }

  const getRoutingPosition = (startPositionId: string, endPositionId: string) => {
    const legs = routingPositions.value?.route?.legs || []
    const leg = legs.filter((item: any) => {
      if (item.startLocation === startPositionId && item.endLocation === endPositionId) {
        return true
      }
      return false
    })

    return leg?.[0] || {}
  }

  const setRoutingPositionTollStations = (startPositionId: string, endPositionId: string, tollStations: any[]) => {
    const legs = routingPositions.value?.route?.legs || []

    const index = legs.findIndex((item: any) => {
      return item.startLocation === startPositionId && item.endLocation === endPositionId
    })

    if (index === -1) {
      return
    }

    routingPositions.value.route.legs[index].tollStations = $lodash.cloneDeep(tollStations)
  }

  const setRoutingPositions = (data?: { [key: string]: any } | null) => {
    routingPositions.value = data || {}
  }

  const setTolltation = async () => {
    const url = $url.quote.quoteRequest.tollStation
    const legs = routingPositions.value?.route?.legs || []
    tollStations.value = []

    if (legs) {
      for (let i = 0; i < legs.length; i++) {
        const leg = legs[i]

        const res = await $api(url, { body: { overViewPolyLine: leg.overViewPolyLine } })

        const resData = res?.data?.value

        if (resData.success) {
          const ts = resData.data
          // vẽ markers trạm thu thí
          if (ts && ts.length) {
            ts.forEach((t: any) => {
              tollStations.value.push({ lat: 0, lng: 0, nodeId: t.locationId, locationName: t.locationName } as google.maps.LatLngLiteral)
            })
          }

          // lưu trạm thu phí vào thông tin chuyến
          legs[i].tollStations = ts || []
        }
      }
    }
  }

  return {
    markers,
    setMarkers,
    routes,
    setRoutes,
    routingPositions,
    getRoutingPosition,
    updateDirections,
    showLocation,
    draggable,
    CLatLngLocationRoutes,
    mapLoading,
    setTolltation,
    setRoutingPositions,
    setRoutingPositionTollStations
  }
}
